/* The first-run list. A card of numbered steps; the step to do now is larger and carries the primary
   action, the rest are quiet. Tokens only (ADR-0007). */

.card {
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
  padding: 16px 18px 18px;
}

.title {
  margin: 0;
  color: var(--ink);
  font-size: var(--t-head);
  font-weight: 650;
}

.list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 760px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.line {
  display: grid;
  /* The state's track is a fixed width, so "Done" and "To do" start and end on the same line in every line
     (alignment audit, 2026-11-03). */
  grid-template-columns: 28px minmax(0, 1fr) 5.5rem 9rem;
  align-items: center;
  gap: 12px;
  min-height: 44px;
  padding: 6px 12px;
  border: 1px solid var(--line);
  border-radius: var(--radius-chip);
  background: var(--panel);
  color: var(--ink);
  font-size: var(--t-body);
}

/* The step to do now: larger, ringed in the accent, on the accent wash. */
.line > :nth-child(n + 3) {
  justify-self: end;
}

.line[data-phase="next"] {
  min-height: 60px;
  padding-block: 10px;
  border-color: var(--accent);
  background: var(--accent-w);
  font-size: var(--t-head);
}

.line[data-state="done"] {
  background: var(--panel-2);
}

.mark {
  display: inline-grid;
  place-items: center;
  width: 28px;
  height: 28px;
  color: var(--muted);
}

.line[data-state="done"] .mark {
  color: var(--ok);
}

.line[data-state="blocked"] .mark {
  color: var(--warn);
}

.number {
  display: grid;
  place-items: center;
  width: 24px;
  height: 24px;
  border: 1.5px solid var(--line-2);
  border-radius: 50%;
  font-size: var(--t-min);
  font-weight: 650;
  font-variant-numeric: lining-nums tabular-nums;
}

.line[data-phase="next"] .number {
  border-color: var(--accent);
  background: var(--accent);
  color: var(--on-fill);
}

.label {
  min-width: 0;
  font-weight: 600;
}

.label a {
  color: inherit;
  text-decoration: none;
}

.label a:hover {
  color: var(--accent);
  text-decoration: underline;
}

.line[data-state="done"] .label {
  color: var(--muted);
  font-weight: 500;
}

.action {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: var(--t-dense);
  font-weight: 600;
}

@media (max-width: 640px) {
  .line {
    grid-template-columns: 28px minmax(0, 1fr) auto;
  }

  .action {
    grid-column: 2 / -1;
    justify-content: flex-start;
  }
}
